import { FC, useState, useEffect, useCallback } from 'react';
import { useStore } from 'hooks/useRootStore';
import { useAppPreloader } from 'hooks/useAppPreloader';
import { useMutation, useQuery } from 'react-query';
import { useHistory } from 'react-router';
import { Link } from 'react-router-dom';
import { useForm, Controller } from 'react-hook-form';
import {
  Paper,
  NativeSelect,
  FormHelperText,
  FormControlLabel,
  Container,
  Grid,
  FormControl,
  Checkbox,
  TextField,
  ListItemText,
  Dialog,
  DialogTitle,
  DialogActions,
  Button,
} from '@material-ui/core';
import { useStyles } from './styles';
import { UserFormInputPattern, UserData, GenericFormProps, Provider } from './types';
import { observer } from 'mobx-react-lite';
import { handleCompanyUrl } from 'utils/organizationUtils';
import ProfileIcon from './../../../../../assets/icons/AdminIcons/Profile.svg';
import LockIcon from './../../../../../assets/icons/AdminIcons/Lock.svg';
import GlobeIcon from './../../../../../assets/icons/AdminIcons/Globe.svg';
import Email from './../../../../../assets/icons/EndUser/Email.svg';
import DescriptionIcon from './../../../../../assets/icons/AdminIcons/Description.svg';
import PhoneIcon from './../../../../../assets/icons/AdminIcons/PhoneIcon.svg';
import HomeAddressIcon from './../../../../../assets/icons/AdminIcons/HomeAddressIcon.svg';
import MuiPhoneNumber from 'material-ui-phone-number-2';
import Calender from './../../../../../assets/icons/EndUser/Calender.svg';
import { toFormatDateTime } from 'utils';
import { Autocomplete } from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import CreateIcon from '@mui/icons-material/Create';
export const GenericForm: FC<GenericFormProps> = observer(({ selfRegister, type, currentUserData }) => {
  const {
    control,
    handleSubmit,
    watch,
    reset,
    formState: { errors },
  } = useForm<UserData>();
  const [typeForm] = useState<string>(type ?? '');
  const [currentUser, setCurrentUser] = useState(currentUserData);
  const [isAppStatusChecked, setisAppStatusChecked] = useState<boolean>(false);
  const [emailValid, setEmailValid] = useState<boolean>(true);
  const [arrayValid, setArrayValid] = useState<boolean>(false);
  const [groupEmailValid, setgroupEmailValid] = useState<boolean>(false);
  const [passwordValid, setPasswordValid] = useState<boolean>(true);
  const [currentUserAllGroup, setcurrentUserAllGroup] = useState([]);
  const [currentEmailAllGroup, setcurrentEmailAllGroup] = useState([]);
  const [passwordStatus, setPasswordStatus] = useState<string>('');
  const [selectedGroups, setSelectedGroups] = useState<any[]>([]);
  const profile = JSON.parse(localStorage.getItem('Profile') as string);
  const [inputValue, setInputValue] = useState<string>('');
  const [options, setOptions] = useState<string[]>([]);
  const [isCancelClicked, setIsCancelClicked] = useState(false);
  const [connected, setconnected] = useState<Provider[]>([]);
  const [passLowerCase, setPassLowerCase] = useState<number>(0);
  const [passUpperCase, setPassUpperCase] = useState<number>(0);
  const [passNumericCase, setPassNumericCase] = useState<number>(0);
  const [passSpecialCase, setPassSpecialCase] = useState<number>(0);
  const [minPass, SetMinPass] = useState<number>(0);
  const [gitHub, SetgitHub] = useState<string>('');
  const [inputValues, setInputValues] = useState({
    givenname: currentUser?.givenname || '',
    sn: currentUser?.sn || '',
    displayname: currentUser?.displayname || '',
    uid: currentUser?.uid || '',
  });

  const [validation, setValidation] = useState({
    givenname: true,
    sn: true,
    displayname: true,
    uid: true,
  });

  const handleValidation = (e: React.ChangeEvent<HTMLInputElement>, key: string) => {
    const value = e.target.value;
    let reg: RegExp, isValid: boolean;

    if (key === 'uid') {
      reg = /^[0-9a-zA-Z_]+$/;
      isValid = value.trim() !== '' && reg.test(value);
    } else {
      reg = /^[A-Za-z]+$/;
      isValid = value.trim() !== '' && reg.test(value);
    }

    setInputValues((prev) => ({ ...prev, [key]: value }));
    setValidation((prev) => ({ ...prev, [key]: isValid }));
  };
  const handleEmailValidation = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const emailValue = e.target.value;
      if (typeof emailValue !== 'string' || !emailValue) {
        setEmailValid(false);
        return;
      }
      const emailParts = emailValue.split('@');
      const domain = emailParts[emailParts.length - 1];
      const connectedDomains: string[] = [];

      connected.forEach((item) => {
        if ((item.provider === 'google' || item.provider === 'microsoft') && item.token && item.client_domain) {
          connectedDomains.push(item.client_domain.toLowerCase());
        }
      });

      if (isAppStatusChecked && connectedDomains.length > 0) {
        if (emailParts.length === 2 && !connectedDomains.includes(domain.toLowerCase())) {
          setEmailValid(false);
          return;
        }
      }
      const reg = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      setEmailValid(reg.test(emailValue));
    },
    [connected, isAppStatusChecked]
  );
  const mailValue = watch('mail');
  useEffect(() => {
    if (mailValue !== undefined && type !== 'EditUser' && type !== 'view') {
      handleEmailValidation({ target: { value: mailValue } } as React.ChangeEvent<HTMLInputElement>);
    }
  }, [handleEmailValidation, mailValue, isAppStatusChecked, type]);
  const passwordPattern = new RegExp(
    `^(?=(?:.*[A-Z]){${passUpperCase},})(?=(?:.*[a-z]){${passLowerCase},})(?=(?:.*\\d){${passNumericCase},})(?=(?:.*[!@#$%^&*()_+={}[]|\\:;"'<>,.?/~\`-]){${passSpecialCase},}).{${minPass},}$`
  );

  const handlePasswordValidation = (e: any) => {
    const value = e.target.value;
    const isEmpty = value.trim() === '';
    const isValid = isEmpty || passwordPattern.test(value);
    setPasswordValid(isValid);
    setInputValue(value);
    setPasswordStatus('yes');
  };
  useEffect(() => {
    setCurrentUser((prev: any) => currentUserData);
  }, [currentUserData]);

  useEffect(() => {
    if (currentUserData) {
      const userData: UserData = {
        ...currentUserData,
        uid: currentUserData.uid ?? '',
        givenname: currentUserData.givenname ?? '',
        notify: currentUserData.notify ?? true,
      };
      reset(userData);
    }
  }, [currentUserData, reset]);

  const {
    ldapStore: {
      updateUser,
      createUser,
      endUserSelfRegister,
      departmentsView,
      getDepartments,
      getGroups,
      allGroupsView,
      createGoogleUser,
      getUsers,
      // getUserTimeline
    },
    AppStore: { providerList, samlList },
    endUserSettingsFormStore: { portalSettingsget, getSettings, settingsByTypeView, attributeget, attributeKey },
    notificationStore: { openNotification },
    appPreloaderStore: { disablePreloader },
  } = useStore();
  const classes = useStyles();
  const history = useHistory();
  const getDepartmentsReq = useQuery('getDepartmentsReq', () => getDepartments(), {
    onError: () => openNotification('error', `Can't get departments`),
  });

  const attributegetReq = useQuery('attributegetReq', () => attributeget(), {
    onError: () => openNotification('error', `Can't get data`),
  });

  const portalSettingsgetReq = useQuery('portalSettingsgetReq', () => portalSettingsget(), {
    onError: () => openNotification('error', `Can't get data`),
  });
  const getSettingsReq = useQuery('getSettingReq', () => getSettings(), {
    onError: () => openNotification('error', `Can't get password policy`),
  });

  // const timelineReq = useQuery(
  //   ['userTimeline', currentUser?.dn],
  //   () => getUserTimeline(currentUser?.dn || ''),
  //   {
  //     enabled: !!(currentUser?.dn && type === 'view'),
  //     onError: () => {
  //       openNotification('error', `Can't get user timeline`);
  //     },
  //   }
  // );

  useEffect(() => {
    settingsByTypeView('password').forEach((group: any, i: any) =>
      group.settings.forEach((setting: any, j: any) => {
        if (setting.key === 'minimumNumberOfLowercaseCharacters') {
          return setPassLowerCase(+setting.value);
        } else if (setting.key === 'minimumNumberOfUppercaseCharacters') {
          return setPassUpperCase(+setting.value);
        } else if (setting.key === 'minimumNumberOfNumericCharacters') {
          return setPassNumericCase(+setting.value);
        } else if (setting.key === 'minimumNumberOfSpecialCharacters') {
          return setPassSpecialCase(+setting.value);
        } else if (setting.key === 'minimumLengthPassword') {
          return SetMinPass(+setting.value);
        } else {
          return 0;
        }
      })
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getSettingsReq.isFetching]);

  const providerListReq = useQuery('providerListReq', () => providerList(), {
    onError: () => openNotification('error', `We are unable to connect `),
  });
  const samlListReq = useQuery('samlListReq', () => samlList(), {
    onError: () => openNotification('error', `We are unable to connect `),
  });

  useEffect(() => {
    if (providerListReq.data) {
      const filteredOptions = providerListReq.data.filter(
        (app: { provider: string; token: any; tokenStatus: string }) => {
          const isActive = app.token && app.tokenStatus === 'active';
          if (!isActive) return false;
          const isGitHub = app.provider === 'github' || app.provider === 'GitHub Workspace';
          if (isGitHub) {
            const githubData =
              providerListReq?.data?.filter((item: { provider: string }) => item.provider === 'github') || [];
            localStorage.setItem('organisation', githubData?.[0].organisation);
            SetgitHub(githubData?.organisation);
          }
          return true;
        }
      );
      setconnected(providerListReq.data);
      const optionView = filteredOptions.map((item: { provider: string }) => {
        if (item.provider.toLowerCase() === 'google') {
          return 'Google Workspace';
        } else if (item.provider.toLowerCase() === 'zoom') {
          return 'Zoom Workspace';
        } else if (item.provider.toLowerCase() === 'microsoft') {
          return 'Microsoft Workspace';
        } else if (item.provider.toLowerCase() === 'github') {
          return 'GitHub Workspace';
        } else {
          return item.provider;
        }
      });
      setOptions(optionView);
      if (filteredOptions.length !== 0) {
        setisAppStatusChecked(true);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [providerListReq.data]);
  const getGroupsReq = useQuery('getGroupsReq', () => getGroups(), {
    onError: () => openNotification('error', `Can't get groups`),
  });
  const updateUserReq = useMutation((data: UserData) => updateUser(data, passwordStatus), {
    mutationKey: 'updateUserReq',
    onSuccess: () => {
      openNotification('success', 'Saved!!');
      if (currentUser) {
        localStorage.removeItem('ClickedUser');
      }
      getUsers();
      history.push(handleCompanyUrl('/users'));
    },
    onError: ({ message }: Error) => openNotification('error', message),
  });
  const goBack = () => {
    localStorage.removeItem('ClickedUser');
    history.goBack();
  };
  const appStatusChecked = watch('appStatus');
  const endUserConfigSettings = JSON.parse(localStorage.getItem('endUserConfigSettings') as string);
  const googleAuthentication = endUserConfigSettings?.googleAuthentication;
  const [isAuthenticateChecked, setisAuthenticateChecked] = useState<boolean>(false);
  const userId = endUserConfigSettings?.userId;
  const createUserReq = useMutation((data: UserData) => (selfRegister ? endUserSelfRegister(data) : createUser(data)), {
    mutationKey: 'createUserReq',
    onSuccess: () => {
      openNotification('success', 'Created Successfully');
      if (currentUser) {
        localStorage.removeItem('ClickedUser');
      }
      if (!selfRegister) {
        getUsers();
        history.push(handleCompanyUrl('/users'));
      } else {
        disablePreloader();
        history.replace(handleCompanyUrl('/'));
      }
    },
    onError: (error: any) => {
      disablePreloader();
      openNotification('error', error?.message);
      if (error.licensePage) {
        history.replace(handleCompanyUrl('/upgrade-license'));
      }
    },
  });
  const createGoogleReq = useMutation((data: UserData) => createGoogleUser(data), {
    mutationKey: 'createGoogleReq',
    onSuccess: () => {
      openNotification('success', 'Sync Successfully');
      if (currentUser) {
        localStorage.removeItem('ClickedUser');
      }
      if (!selfRegister) {
        history.push(handleCompanyUrl('/users'));
      } else {
        disablePreloader();
        history.replace(handleCompanyUrl('/'));
      }
    },
    onError: (error: any) => {
      disablePreloader();
      openNotification('error', 'We are unable to sync user with google');

      if (error.licensePage) {
        history.replace(handleCompanyUrl('/upgrade-license'));
      }
    },
  });
  useAppPreloader(
    updateUserReq.isLoading ||
    createUserReq.isLoading ||
    getDepartmentsReq.isFetching ||
    getGroupsReq.isFetching ||
    portalSettingsgetReq.isFetching ||
    createGoogleReq.isLoading ||
    getSettingsReq.isFetching ||
    attributegetReq.isFetching
  );
  useEffect(() => {
    const tempcurrentUserAllGroup: any = [];
    const tempcurrentEmailAllGroup: any = [];
    allGroupsView.forEach((group) => {
      if (Array.isArray(group.memberuid)) {
        group.memberuid.forEach((element) => {
          if (element === currentUser?.dn) {
            if (group?.dn && !tempcurrentUserAllGroup.includes(group.dn)) {
              if (group?.email && !tempcurrentEmailAllGroup.includes(group.email)) {
                tempcurrentEmailAllGroup.push(group.email);
              }
              tempcurrentUserAllGroup.push(group.dn);
            }
          }
        });
      }
    });
    setcurrentEmailAllGroup(tempcurrentEmailAllGroup);
    setcurrentUserAllGroup(tempcurrentUserAllGroup);
  }, [allGroupsView, currentUser?.dn]);

  function arraysAreIdentical(arr1: any, arr2: any) {
    if (arr1.length !== arr2.length) {
      return false;
    }
    for (let i = 0; i < arr1.length; i++) {
      if (arr1[i] !== arr2[i]) {
        return false;
      }
    }
    return true;
  }

  useEffect(() => {
    const array1 = currentUserAllGroup;
    const transformedGroups = selectedGroups.map((group) => group.dn);
    const array2 = transformedGroups;
    const array = arraysAreIdentical(array1, array2);
    const email1 = currentEmailAllGroup;
    const transformedEmailGroups = selectedGroups.map((group) => group.email);
    const email2 = transformedEmailGroups;
    const email = arraysAreIdentical(email1, email2);
    setArrayValid(array);
    setgroupEmailValid(email);
  }, [currentUserAllGroup, selectedGroups, currentEmailAllGroup]);

  useEffect(() => {
    const mappedGroups = currentUserAllGroup.map((dn) => {
      const group = allGroupsView.find((item) => item.dn === dn);
      return { dn, label: group?.cn, email: group?.email };
    });
    setSelectedGroups(mappedGroups);
  }, [allGroupsView, currentUserAllGroup]);

  const handleGroupChange = (event: React.SyntheticEvent, newValue: any[]) => {
    const uniqueGroups = newValue.filter((group, index, self) => index === self.findIndex((g) => g.dn === group.dn));
    setSelectedGroups(uniqueGroups);
  };
  useEffect(() => {
    if (type === 'EditUser' || type === 'view') {
      setisAuthenticateChecked(currentUserData?.isTwoFactorEnable || false);
    }
  }, [currentUserData, type]);
  const permission = profile?.permission;
  const onSubmit = (data: UserData) => {
    const samlData: any[] = samlListReq.data?.data || [];
    const toProviderKey = (option: string) => {
      if (option === 'Google Workspace') return 'google';
      if (option === 'Zoom Workspace') return 'zoom';
      if (option === 'Microsoft Workspace') return 'microsoft';
      if (option === 'GitHub Workspace') return 'github';
      const samlItem = samlData.find((s: any) => s.name === option);
      if (samlItem) return `saml:${samlItem.uuid}`;
      return option;
    };
    const mappedOptions = selectedOptions.map(toProviderKey);
    const removeOption = removedOption.map(toProviderKey);
    delete data.locked;
    const transformedGroups = selectedGroups.map((group) => group.dn);
    const transformedEmailGroups = selectedGroups.map((group) => group.email);
    data.group = transformedGroups;
    data.updateStatusGroup = JSON.stringify(transformedGroups) === JSON.stringify(currentUserAllGroup) ? false : true;
    data.oldgroup = arrayValid ? [] : currentUserAllGroup;
    data.groupEmails = transformedEmailGroups;
    data.reSyncProvider = isAppStatusChecked === false ? [] : mappedOptions;
    data.oldGroupEmails = groupEmailValid ? [] : currentEmailAllGroup;
    data.base = data.base || '/';
    data.deleteProvider =
      isAppStatusChecked === false
        ? mappedOptions.length === 0
          ? removeOption
          : mappedOptions
        : isCancelClicked
          ? []
          : removeOption;
    data.updateStatusProvider =
      JSON.stringify(mappedOptions) === JSON.stringify(currentUser?.reSyncProvider) ? false : true;
    data.deleteProviderType = isAppStatusChecked === false ? 'yes' : isCancelClicked ? 'no' : confirm;
    data.gitOrg = gitHub || localStorage.getItem('organisation') || '';
    const customAttributes = attributeKey.map((attr: any) => ({
      label: attr.label,
      type: attr.type,
      name: attr.name,
      options: attr.options || [],
      value: data[attr.name as keyof UserData] || null,
    }));
    attributeKey.forEach((attr: any) => {
      delete data[attr.name as keyof UserData];
    });
    data.customAttribute = customAttributes;
    const updatedFormData = {
      ...data,
      appStatus: isAppStatusChecked,
      isTwoFactorEnable: isAuthenticateChecked,
    };
    (!!currentUser as boolean) ? (data.updatedBy = permission) : (data.createdBy = permission);
    (!!currentUser as boolean) ? updateUserReq.mutate(updatedFormData) : createUserReq.mutate(updatedFormData);
  };
  const selected = currentUser?.reSyncProvider;
  const [confirm, setConfirm] = useState('no');
  const [selectedOptions, setSelectedOptions] = useState<string[]>(currentUser?.reSyncProvider || []);
  const [openPopup, setOpenPopup] = useState(false);
  const [optionToUncheck, setOptionToUncheck] = useState<string | null>(null);
  const [previousSelectedOptions, setPreviousSelectedOptions] = useState<string[]>([]);
  const [removedOption, setRemovedOption] = useState<string[]>([]);
  useEffect(() => {
    if (currentUser?.reSyncProvider) {
      const samlData: any[] = samlListReq.data?.data || [];
      const mapped = currentUser.reSyncProvider.map((provider: string) => {
        if (provider === 'google') return 'Google Workspace';
        if (provider === 'zoom') return 'Zoom Workspace';
        if (provider === 'microsoft') return 'Microsoft Workspace';
        if (provider === 'github') return 'GitHub Workspace';
        if (provider.startsWith('saml:')) {
          const uuid = provider.replace('saml:', '');
          const found = samlData.find((s: any) => s.uuid === uuid);
          return found ? found.name : provider;
        }
        return provider;
      });
      setSelectedOptions(mapped);
    }
  }, [currentUser, samlListReq.data]);

  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>, option: string) => {
    const isChecked = event.target.checked;
    if (isChecked) {
      setSelectedOptions((prevOptions) => {
        if (!prevOptions.includes(option)) {
          return [...prevOptions, option];
        }
        return prevOptions;
      });
    } else if (selected?.length === 0) {
      setPreviousSelectedOptions(selectedOptions);
      setOptionToUncheck(option);
      setOpenPopup(true);
    } else {
      setPreviousSelectedOptions(selectedOptions);
      setOptionToUncheck(option);
      setOpenPopup(true);
    }
  };

  const handleConfirm = () => {
    if (optionToUncheck) {
      setSelectedOptions((prevOptions: any[]) => prevOptions.filter((item: string) => item !== optionToUncheck));
      setRemovedOption((prev) => [...prev, optionToUncheck]);
      setOptionToUncheck(null);
      setConfirm('yes');
    }
    setOpenPopup(false);
  };
  const handleCancel = () => {
    setSelectedOptions(previousSelectedOptions);
    setOptionToUncheck(null);
    setOpenPopup(false);
    setIsCancelClicked(true);
  };

  const mockDataPers1: UserFormInputPattern[] = [
    { label: 'First name', key: 'givenname', required: true, icon: ProfileIcon, autoFocus: false, placeholder: 'John' },
    { label: 'Middle name', key: 'displayname', required: false, icon: ProfileIcon, placeholder: 'Riley' },
    { label: 'Last name', key: 'sn', required: true, icon: ProfileIcon, placeholder: 'Collins' },
    {
      label: endUserConfigSettings?.userId === null || endUserConfigSettings?.userId === '' ? 'User Id' : userId,
      key: 'uid',
      required: true,
      disable: typeForm === 'EditUser' || typeForm === 'view' ? true : false,
      pattern: {
        regexp: /^[0-9a-zA-Z_]+$/,
        errorMessage: 'The UID must not contain spaces or special characters',
      },
      icon: ProfileIcon,
      placeholder: 'example12',
    },
    ...(typeForm === 'view'
      ? []
      : [
          {
            label: 'Password',
            key: 'userpassword' as keyof UserData,
            pattern: {
              regexp: passwordPattern,
              errorMessage: `Password must contain at least ${passUpperCase} uppercase, ${passLowerCase} lowercase, ${passSpecialCase} special characters, ${passNumericCase} numeric value(s), and minimum ${minPass} characters.`,
            },
            required: !currentUser as boolean,
            icon: LockIcon,
            placeholder: 'EXample@@12',
          },
        ]),
    {
      label: 'Email',
      key: 'mail',
      pattern: {
        regexp: /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
        errorMessage: 'Please enter a valid email address',
      },
      icon: Email,
      required: true,
      disable: typeForm === 'EditUser' || typeForm === 'view' ? true : false,
      placeholder: 'example01@gmail.com',
    },

    { label: 'CN', key: 'cn', required: false, disable: true },
    { label: 'DN', key: 'dn', required: false, disable: true },
    {
      label: 'Preferred language',
      key: 'preferredlanguage',
      type: 'select',
      defaultValue: 'en_US',
      icon: GlobeIcon,
      options: [
        { value: 'af_ZA', label: 'Afrikaans (Afrikaans)' },
        { value: 'ar_EG', label: 'Arabic (عربية)' },
        { value: 'pt_BR', label: 'Brazilian (Português (Brasil))' },
        { value: 'ca_ES', label: 'Catalan (Català)' },
        { value: 'zh_CN', label: 'Chinese (中文, 汉语, 漢語)' },
        { value: 'es_CO', label: 'Colombian Spanish (Español Colombiano)' },
        { value: 'cs_CZ', label: 'Czech (Česky)' },
        { value: 'nl_NL', label: 'Dutch (Nederlands)' },
        { value: 'en_US', label: 'English (English)' },
        { value: 'fi_FI', label: 'Finnish (Suomi)' },
        { value: 'fr_FR', label: 'French (Français)' },
        { value: 'de_DE', label: 'German (Deutsch)' },
        { value: 'el_GR', label: 'Greek (ελληνικά)' },
        { value: 'hu_HU', label: 'Hungarian (Magyar)' },
        { value: 'id_ID', label: 'Indonesian (Bahasa Indonesia)' },
        { value: 'it_IT', label: 'Italian (Italiano)' },
        { value: 'ja_JP', label: 'Japanese (日本語)' },
        { value: 'ko_KR', label: 'Korean (한국어)' },
        { value: 'lv_LV', label: 'Latvian (Latviešu valoda)' },
        { value: 'nb_NO', label: 'Norwegian Bokmål (Norsk bokmål)' },
        { value: 'fa_IR', label: 'Persian (پارسی)' },
        { value: 'pl_PL', label: 'Polish (Polski)' },
        { value: 'pt_PT', label: 'Portuguese (Português)' },
        { value: 'ru_RU', label: 'Russian (русский язык)' },
        { value: 'es_ES', label: 'Spanish (Español)' },
        { value: 'sv_SE', label: 'Swedish (Svenska)' },
        { value: 'zh_TW', label: 'Taiwanese (Taiwanese)' },
        { value: 'tr_TR', label: 'Turkish (Türkçe)' },
        { value: 'es_VE', label: 'Venezuelan (Castellano)' },
        { value: 'vi_VN', label: 'Vietnamese (Tiếng Việt)' },
      ],
    },
    { label: 'Description', key: 'description', icon: DescriptionIcon, placeholder: 'Description' },
  ];

  const mockDataPers2: UserFormInputPattern[] = [
    {
      label: 'Address',
      key: 'homepostaladdress',
      icon: HomeAddressIcon,
      placeholder: '1234 Main St, Springfield, IL 62704',
      multiline: true,
    },
    { label: 'Private phone', key: 'homephone', icon: PhoneIcon, placeholder: '123-456-789' },
    ...(typeForm === 'view'
      ? [
          {
            label: 'Created',
            key: 'createtimestamp' as keyof UserData,
            required: !currentUser as boolean,
            icon: Calender,
          },
          {
            label: 'Last Updated',
            key: 'modifytimestamp' as keyof UserData,
            required: !currentUser as boolean,
            icon: Calender,
          },
        ]
      : []),
  ];

  const getCNFromDN = (selectedDNs: any, allGroupsView: any) => {
    return selectedDNs.map((selectedDN: any) => {
      const foundGroup = allGroupsView.find((group: any) => group.dn === selectedDN);
      return foundGroup ? foundGroup.cn : selectedDN;
    });
  };
  return (
    <>
      {currentUserData?.gitStatus === 'invited' && (type === 'EditUser' || type === 'view') && (
        <div
          style={{
            color: 'red',
            padding: '12px 16px',
            marginBottom: '16px',
            borderRadius: '4px',
            border: '1px solid red',
            textAlign: 'center',
            fontSize: '14px',
          }}
        >
          This user has been invited to GitHub but hasn't accepted yet, so we can't make changes to the account.
        </div>
      )}
      <form onSubmit={handleSubmit(onSubmit)} className={classes.box}>
        <Grid container justify='space-between'>
          <Paper className={classes.paper}>
            <p className={classes.boxTitle}>General Information</p>
            <Grid container>
              <Container className={classes.tableBox}>
                {mockDataPers1.map((item, index) => (
                  <Controller
                    name={item.key}
                    key={index}
                    defaultValue={
                      item.key !== 'userpassword' ? currentUser?.[item.key] || item?.defaultValue : undefined
                    }
                    control={control}
                    rules={{ required: item?.required }}
                    render={({ field, fieldState: { invalid, error } }) => (
                      <Grid key={index} container className={item?.multiline ? classes.rowWide : classes.row}>
                        {item.type === 'select' ? (
                          <FormControl
                            className={invalid ? classes.inputError : classes.input}
                            style={{ display: 'flex', flexDirection: 'row', gap: '8px' }}
                          >
                            <span style={{ display: 'flex' }}>
                              <img src={item.icon} alt='' />
                            </span>
                            <NativeSelect
                              {...field}
                              error={invalid}
                              fullWidth
                              disabled={type === 'view'}
                              autoFocus={item?.autoFocus}
                            >
                              {item?.options
                                ? item.options.map((item) => (
                                    <option key={item.value} value={item.value}>
                                      {item.label}
                                    </option>
                                  ))
                                : null}
                            </NativeSelect>
                            {invalid ? <FormHelperText error>Required field</FormHelperText> : null}
                          </FormControl>
                        ) : item.key === 'givenname' || item.key === 'sn' || item.key === 'displayname' ? (
                          <div style={{ display: 'flex', width: '100%', gap: '8px' }}>
                            <span style={{ display: 'flex' }}>
                              <img src={item.icon} alt='' />
                            </span>
                            <TextField
                              {...field}
                              variant='standard'
                              label={item.label}
                              defaultValue={currentUser?.[item.key]}
                              autoFocus={item?.autoFocus}
                              className={invalid || !validation[item.key] ? classes.inputError : classes.input}
                              multiline={item?.multiline}
                              rows={item?.multiline ? 4 : 1}
                              placeholder={item.placeholder}
                              onChangeCapture={(e: any) => handleValidation(e, item.key)}
                              error={invalid || !validation[item.key]}
                              disabled={type === 'view' || item.disable}
                              helperText={
                                !validation[item.key] && inputValues[item.key].trim() !== ''
                                  ? 'There must be no space at the start, no numeric values, and no special characters'
                                  : invalid
                                    ? error?.type === 'pattern'
                                      ? item.pattern?.errorMessage
                                      : 'Required field'
                                    : ''
                              }
                            />
                          </div>
                        ) : item.key === 'mail' ? (
                          <div style={{ display: 'flex', width: '100%', gap: '8px' }}>
                            <span style={{ display: 'flex' }}>
                              <img src={item.icon} alt='' />
                            </span>
                            <TextField
                              {...field}
                              variant='standard'
                              label={item.label}
                              defaultValue={currentUser?.[item.key]}
                              autoFocus={item?.autoFocus}
                              className={invalid ? classes.inputError : classes.input}
                              multiline={item?.multiline}
                              rows={item?.multiline ? 4 : 1}
                              placeholder={item.placeholder}
                              onChangeCapture={handleEmailValidation}
                              error={invalid || (!emailValid && item.key === 'mail')}
                              disabled={type === 'view' || type === 'EditUser' || item.disable}
                              helperText={
                                !emailValid && item.key === 'mail'
                                  ? isAppStatusChecked &&
                                    connected.some(
                                      (item) =>
                                        item.token && (item.provider === 'google' || item.provider === 'microsoft')
                                    )
                                    ? (() => {
                                      const googleDomain = connected.find(
                                        (item) => item.token && item.provider === 'google'
                                      )?.client_domain;
                                      const microsoftDomain = connected.find(
                                        (item) => item.token && item.provider === 'microsoft'
                                      )?.client_domain;

                                      if (googleDomain && microsoftDomain) {
                                        return `Email domain must match one of: ${googleDomain}, ${microsoftDomain}`;
                                      } else if (googleDomain) {
                                        return `Email domain must match ${googleDomain} (Google Workspace)`;
                                      } else if (microsoftDomain) {
                                        return `Email domain must match ${microsoftDomain} (Microsoft Workspace)`;
                                      }
                                      return 'Please enter a valid email address';
                                    })()
                                    : 'Please enter a valid email address'
                                  : invalid
                                    ? error?.type === 'pattern'
                                      ? item.pattern?.errorMessage
                                      : 'Required field'
                                    : ' '
                              }
                            />
                          </div>
                        ) : item.key === 'userpassword' ? (
                          <div style={{ display: 'flex', width: '100%', gap: '8px' }}>
                            <span style={{ display: 'flex' }}>
                              <img src={item.icon} alt='' />
                            </span>
                            <TextField
                              {...field}
                              variant='standard'
                              label={item.label}
                              defaultValue={currentUser?.[item.key]}
                              autoFocus={item?.autoFocus}
                              className={invalid ? classes.inputError : classes.input}
                              multiline={item?.multiline}
                              rows={item?.multiline ? 4 : 1}
                              placeholder={item.placeholder}
                              onChangeCapture={(e: any) => handlePasswordValidation(e)}
                              error={invalid || (!passwordValid && inputValue.trim() !== '')}
                              disabled={type === 'view' || item.disable}
                              helperText={
                                !passwordValid && inputValue.trim() !== ''
                                  ? `Password must contain at least ${passUpperCase} uppercase, ${passLowerCase} lowercase, ${passSpecialCase} special characters, ${passNumericCase} numeric value(s), and minimum ${minPass} characters.`
                                  : invalid
                                    ? error?.type === 'pattern'
                                      ? item.pattern?.errorMessage
                                      : 'Required field'
                                    : ''
                              }
                            />
                          </div>
                        ) : item.key === 'uid' ? (
                          <div style={{ display: 'flex', width: '100%', gap: '8px' }}>
                            <span style={{ display: 'flex' }}>
                              <img src={item.icon} alt='' />
                            </span>
                            <TextField
                              {...field}
                              variant='standard'
                              label={item.label}
                              defaultValue={currentUser?.[item.key]}
                              autoFocus={item?.autoFocus}
                              className={invalid ? classes.inputError : classes.input}
                              multiline={item?.multiline}
                              rows={item?.multiline ? 4 : 1}
                              placeholder={item.placeholder}
                              onChangeCapture={(e: any) => handleValidation(e, item.key)}
                              error={invalid || !validation[item.key]}
                              disabled={type === 'view' || item.disable}
                              helperText={
                                !validation[item.key] && inputValues[item.key].trim() !== ''
                                  ? 'The UID must not contain spaces or special characters'
                                  : invalid
                                    ? error?.type === 'pattern'
                                      ? item.pattern?.errorMessage
                                      : 'Required field'
                                    : ''
                              }
                            />
                          </div>
                        ) : (
                          <div style={{ display: 'flex', width: '100%', gap: '8px' }}>
                            <span style={{ display: 'flex' }}>
                              <img src={item.icon} alt='' />
                            </span>
                            <TextField
                              {...field}
                              variant='standard'
                              label={item.label}
                              defaultValue={currentUser?.[item.key]}
                              autoFocus={item?.autoFocus}
                              className={invalid ? classes.inputError : classes.input}
                              multiline={item?.multiline}
                              rows={item?.multiline ? 4 : 1}
                              placeholder={item.placeholder}
                              error={invalid}
                              disabled={type === 'view' || item.disable}
                              helperText={
                                invalid
                                  ? error?.type === 'pattern'
                                    ? item.pattern?.errorMessage
                                    : 'Required field'
                                  : ''
                              }
                            />
                          </div>
                        )}
                      </Grid>
                    )}
                  />
                ))}
              </Container>
            </Grid>
            <p className={classes.boxTitle}>Personal Information</p>
            <Grid container>
              <Container className={classes.tableBox}>
                {mockDataPers2.map((item, index) =>
                  item.key === 'homephone' ? (
                    <Controller
                      key={index}
                      name={item.key}
                      defaultValue={
                        currentUser?.telephonenumber
                          ? currentUser?.telephonenumber
                          : item.key
                            ? currentUser?.[item.key]
                            : undefined
                      }
                      control={control}
                      rules={{ required: item?.required }}
                      render={({ field, fieldState: { invalid, error } }) => (
                        <FormControl fullWidth>
                          <Grid
                            key={index}
                            container
                            style={{ display: 'flex', gap: '8px' }}
                            className={item?.multiline ? classes.rowWide : classes.row}
                          >
                            <img src={item.icon} alt='' />
                            <MuiPhoneNumber
                              {...field}
                              label={item.label}
                              disabled={type === 'view'}
                              autoFocus={item?.autoFocus}
                              className={classes.inputphone}
                              multiline={item?.multiline}
                              rows={item?.multiline ? 4 : 1}
                              placeholder='(123) 456-7890'
                              helperText={
                                invalid
                                  ? error?.type === 'pattern'
                                    ? item.pattern?.errorMessage
                                    : 'Required field'
                                  : ''
                              }
                              data-cy='user-phone'
                              defaultCountry='us'
                              variant='standard'
                              color='warning'
                            />
                          </Grid>
                        </FormControl>
                      )}
                    />
                  ) : item.key === 'createtimestamp' || item.key === 'modifytimestamp' ? (
                    <Controller
                      key={index}
                      name={item.key}
                      defaultValue={item.key ? currentUser?.[item.key] : undefined}
                      control={control}
                      rules={{ required: item?.required }}
                      render={({ field, fieldState: { invalid, error } }) => (
                        <Grid
                          key={index}
                          container
                          style={{ display: 'flex', gap: '8px' }}
                          className={item?.multiline ? classes.rowWide : classes.row}
                        >
                          <img src={item.icon} alt='' />
                          <TextField
                            {...field}
                            variant='standard'
                            label={item.label}
                            disabled={type === 'view'}
                            autoFocus={item?.autoFocus}
                            className={classes.inputTwo}
                            multiline={item?.multiline}
                            rows={item?.multiline ? 4 : 1}
                            placeholder={item.placeholder}
                            value={toFormatDateTime(field.value)}
                            error={invalid}
                            helperText={
                              invalid ? (error?.type === 'pattern' ? item.pattern?.errorMessage : 'Required field') : ''
                            }
                          />
                        </Grid>
                      )}
                    />
                  ) : (
                    <Controller
                      key={index}
                      name={item.key}
                      defaultValue={item.key ? currentUser?.[item.key] : undefined}
                      control={control}
                      rules={{ required: item?.required }}
                      render={({ field, fieldState: { invalid, error } }) => (
                        <Grid
                          key={index}
                          container
                          style={{ display: 'flex', gap: '8px' }}
                          className={item?.multiline ? classes.rowWide : classes.row}
                        >
                          <img src={item.icon} alt='' />
                          <TextField
                            {...field}
                            variant='standard'
                            label={item.label}
                            disabled={type === 'view'}
                            autoFocus={item?.autoFocus}
                            className={classes.inputTwo}
                            multiline={item?.multiline}
                            rows={item?.multiline ? 2 : 1}
                            placeholder={item.placeholder}
                            error={invalid}
                            helperText={
                              invalid ? (error?.type === 'pattern' ? item.pattern?.errorMessage : 'Required field') : ''
                            }
                          />
                        </Grid>
                      )}
                    />
                  )
                )}
              </Container>
            </Grid>
          </Paper>
          <Paper className={classes.paper}>
            <p className={classes.boxTitle}>Custom Attribute</p>
            <Container className={classes.tableBox}>
              <>
                {attributeKey?.length > 0
                  ? attributeKey.map((attr: any) => (
                    <>
                      {attr.type === 'select' ? (
                        <>
                          <p className={classes.boxTitle}>{attr.label}</p>
                          <Grid className={classes.row} container justify='space-between'>
                            <Controller
                              key={attr.name}
                              name={attr.name as keyof UserData}
                              control={control}
                              defaultValue={
                                currentUser?.customAttribute.find((attri: any) => attri.name === attr.name)?.value ||
                                ''
                              }
                              render={({ field }) => (
                                <Autocomplete
                                  {...field}
                                  className={classes.input}
                                  options={attr.options || []}
                                  disabled={type === 'view'}
                                  getOptionLabel={(option) => option}
                                  value={attr.options?.find((opt: any) => opt === field.value) || null}
                                  onChange={(_, newValue) => field.onChange(newValue)}
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      variant='outlined'
                                      className={classes.input}
                                      disabled={type === 'view'}
                                    />
                                  )}
                                />
                              )}
                            />
                          </Grid>
                        </>
                      ) : attr.type === 'checkbox' ? (
                        <>
                          <p className={classes.boxCheck}>{attr.label}</p>
                          <div style={{ marginBottom: '20px' }}>
                            {Array.isArray(attr.options) ? (
                              <Controller
                                name={attr.name}
                                control={control}
                                defaultValue={(() => {
                                  const foundValue = currentUser?.customAttribute.find(
                                    (attri: any) => attri.name === attr.name
                                  )?.value;
                                  return typeof foundValue === 'string' ? foundValue : '';
                                })()}
                                disabled={type === 'view'}
                                render={({ field }) => {
                                  const selectedValues = field.value
                                    ? field.value
                                      .split(',')
                                      .map((v: string) => v.trim())
                                      .filter(Boolean)
                                    : [];
                                  return attr.options.map((option: string) => {
                                    const isChecked = selectedValues.includes(option);
                                    return (
                                      <FormControlLabel
                                        key={option}
                                        disabled={type === 'view'}
                                        control={
                                          <Checkbox
                                            checked={isChecked}
                                            onChange={(e) => {
                                              const newValues = e.target.checked
                                                ? [...selectedValues, option]
                                                : selectedValues.filter((val: string) => val !== option);
                                              field.onChange(newValues.join(','));
                                            }}
                                          />
                                        }
                                        label={option}
                                      />
                                    );
                                  });
                                }}
                              />
                            ) : (
                              <p>No options available</p>
                            )}
                          </div>
                        </>
                      ) : attr.type === 'date' ? (
                        <Grid
                          key={attr.name}
                          container
                          style={{ display: 'flex', gap: '8px', marginBottom: '20px' }}
                          className={classes.row}
                        >
                          <Controller
                            key={attr.name}
                            name={attr.name as keyof UserData}
                            control={control}
                            defaultValue={
                              currentUser?.customAttribute.find((attri: any) => attri.name === attr.name)?.value || ''
                            }
                            rules={{ required: 'Date is required' }}
                            render={({ field, fieldState }) => (
                              <TextField
                                {...field}
                                type='date'
                                variant='outlined'
                                label={attr.label}
                                fullWidth
                                disabled={type === 'view'}
                                InputLabelProps={{ shrink: true }}
                                error={!!fieldState.error}
                                helperText={fieldState.error?.message}
                              />
                            )}
                          />
                        </Grid>
                      ) : (
                        <div style={{ display: 'flex', width: '100%', gap: '8px', marginBottom: '20px' }}>
                          <span style={{ display: 'flex' }}>
                            <CreateIcon style={{ color: 'grey' }} />
                          </span>
                          <Controller
                            key={attr.name}
                            name={attr.name as keyof UserData}
                            defaultValue={
                              currentUser?.customAttribute.find((attri: any) => attri.name === attr.name)?.value || ''
                            }
                            control={control}
                            rules={{ required: false }}
                            render={({ field, fieldState: { invalid, error } }) => (
                              <TextField
                                style={{ marginBottom: '10px' }}
                                {...field}
                                variant='standard'
                                label={attr.label}
                                disabled={type === 'view'}
                                className={classes.input}
                                error={invalid}
                                helperText={invalid ? (error?.type === 'pattern' ? '' : 'Required field') : ''}
                              />
                            )}
                          />
                        </div>
                      )}
                    </>
                  ))
                  : null}
                <div style={{ marginBottom: '20px' }}>
                  <FormControlLabel
                    className={classes.notify}
                    control={
                      <Controller
                        name='isTwoFactorEnable'
                        defaultValue={isAuthenticateChecked}
                        key={'isTwoFactorEnable'}
                        control={control}
                        render={({ field }) => (
                          <Checkbox
                            disabled={type === 'view'}
                            {...field}
                            defaultChecked={
                              type === 'EditUser' || type === 'view'
                                ? currentUserData?.isTwoFactorEnable || false
                                : googleAuthentication === 'true'
                            }
                            onChange={(e) => {
                              const isChecked = e.target.checked;
                              setisAuthenticateChecked(isChecked);
                              field.onChange(isChecked);
                            }}
                            name='isTwoFactorEnable'
                          />
                        )}
                      />
                    }
                    label='Enable Google Authentication MFA'
                  />
                </div>
                <div style={{ marginBottom: '20px' }}>
                  <Controller
                    key='end_date'
                    name='end_date'
                    defaultValue={currentUser?.end_date}
                    control={control}
                    rules={{ required: false }}
                    render={({ field, fieldState: { invalid, error } }) => (
                      <Grid container className={classes.row}>
                        <p className={classes.title}> Active Till </p>
                        {
                          <TextField
                            {...field}
                            type='date'
                            error={invalid}
                            disabled={type === 'view'}
                            helperText={invalid ? 'Required field' : ''}
                            className={classes.input}
                            InputLabelProps={{ shrink: true }}
                          />
                        }
                      </Grid>
                    )}
                  />
                </div>

                {type !== 'view' && (
                  <>
                    <div style={{ marginBottom: '20px' }}>
                      <FormControlLabel
                        className={classes.notify}
                        control={
                          <Controller
                            name='appStatus'
                            control={control}
                            defaultValue={isAppStatusChecked}
                            render={({ field }) => (
                              <Checkbox
                                disabled={type === 'view'}
                                defaultChecked={isAppStatusChecked}
                                checked={isAppStatusChecked}
                                onChange={(e) => {
                                  setisAppStatusChecked(e.target.checked);
                                  field.onChange(e.target.checked);
                                }}
                                name='appStatus'
                              />
                            )}
                          />
                        }
                        label={type === 'EditUser' ? (
                          <p style={{ fontWeight: '500', fontSize: '20' }}> Assign App </p>
                        ) : (
                          <p style={{ fontWeight: '500', fontSize: '20' }}> Select Apps </p>
                        )}
                      />
                      <Grid className={classes.row} container justify='space-between'>
                        <FormControl fullWidth>
                          <Controller
                            name="reSyncProvider"
                            control={control}
                            rules={{
                              required: isAppStatusChecked && selectedOptions.length === 0,
                            }}
                            render={({ field }) => {
                              const samlOptions = (samlListReq.data?.data || []).map(
                                (item: any) => ({
                                  label: item.name,
                                  group: "SAML App",
                                })
                              );
                              const groupedOptions = [
                                ...options.map((o: string) => ({
                                  label: o,
                                  group: "Provision App",
                                })),
                                ...samlOptions,
                              ];

                              return (
                                <Autocomplete
                                  multiple
                                  disablePortal
                                  options={groupedOptions}
                                  groupBy={(option) => option.group}
                                  getOptionLabel={(option) => option.label}
                                  value={groupedOptions.filter((o) =>
                                    selectedOptions.includes(o.label)
                                  )}
                                  disabled={type === "view" || isAppStatusChecked === false}
                                  isOptionEqualToValue={(option, value) =>
                                    option.label === value.label
                                  }
                                  onChange={(_, newValue) => {
                                    const newLabels = newValue.map((v) => v.label);
                                    const added = newLabels.find(
                                      (l) => !selectedOptions.includes(l)
                                    );
                                    const removed = selectedOptions.find(
                                      (l) => !newLabels.includes(l)
                                    );
                                    if (added) {
                                      handleCheckboxChange(
                                        {
                                          target: { checked: true },
                                        } as React.ChangeEvent<HTMLInputElement>,
                                        added
                                      );
                                    }

                                    if (removed) {
                                      handleCheckboxChange(
                                        {
                                          target: { checked: false },
                                        } as React.ChangeEvent<HTMLInputElement>,
                                        removed
                                      );
                                    }

                                    setSelectedOptions(newLabels);
                                    field.onChange(newLabels);
                                  }}
                                  renderGroup={(params) => (
                                    <li key={params.key}>
                                      <div
                                        style={{
                                          fontWeight: 700,
                                          fontSize: "14px",
                                          padding: "8px 16px",
                                          backgroundColor: "#f5f5f5",
                                          color: "#333",
                                        }}
                                      >
                                        {params.group}
                                      </div>

                                      <ul
                                        style={{
                                          padding: 0,
                                          margin: 0,
                                        }}
                                      >
                                        {params.children}
                                      </ul>
                                    </li>
                                  )}
                                  renderOption={(props, option) => (
                                    <li
                                      {...props}
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      <Checkbox
                                        checked={selectedOptions.includes(option.label)}
                                        style={{ marginRight: 8 }}
                                      />

                                      <ListItemText primary={option.label} />
                                    </li>
                                  )}
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      variant="outlined"
                                      error={
                                        !!errors.reSyncProvider &&
                                        isAppStatusChecked &&
                                        selectedOptions.length === 0
                                      }
                                      helperText={
                                        !!errors.reSyncProvider &&
                                          isAppStatusChecked &&
                                          selectedOptions.length === 0
                                          ? "Please select at least one option"
                                          : ""
                                      }
                                      disabled={type === "view"}
                                    />
                                  )}
                                />
                              );
                            }}
                          />
                        </FormControl>
                      </Grid>
                      <Dialog
                        open={openPopup}
                        onClose={handleCancel}
                        aria-labelledby='confirm-dialog-title'
                        aria-describedby='confirm-dialog-description'
                      >
                        <DialogTitle>
                          As you have unselected synchronization, do you want to delete this option from all unchecked
                          third-party apps?
                        </DialogTitle>
                        <DialogActions>
                          <Button onClick={handleCancel} color='primary'>
                            Cancel
                          </Button>
                          <Button onClick={handleConfirm} color='primary'>
                            Confirm
                          </Button>
                        </DialogActions>
                      </Dialog>
                    </div>
                  </>
                )}

                {type === 'view' && (
                  <Container className={classes.tableBox}>
                    <p className={classes.boxTitle}>Devices Used </p>
                    <Grid className={classes.row} container justify='space-between'>
                      <FormControl fullWidth>
                        <Controller
                          name='devices'
                          control={control}
                          defaultValue={currentUser?.devices}
                          render={() => (
                            <>
                              <TextField
                                variant='outlined'
                                disabled={type === 'view'}
                                value={currentUser?.devices?.join(', ') || 'No devices'}
                              />
                            </>
                          )}
                        />
                      </FormControl>
                    </Grid>
                  </Container>
                )}
                {type === 'view' && (
                  <>
                      <div style={{ marginBottom: '20px' }}>
                        <FormControlLabel
                          className={classes.notify}
                          control={
                            <Controller
                              name='appStatus'
                              defaultValue={isAppStatusChecked}
                              key={'appStatus'}
                              control={control}
                              render={({ field }) => (
                                <Checkbox
                                  disabled={type === 'view'}
                                  {...field}
                                  defaultChecked={currentUser?.googleId ? true : false}
                                  onChange={field.onChange}
                                  name='appStatus'
                                />
                              )}
                            />
                          }
                          label={<p style={{ fontWeight: '500', fontSize: '20' }}>Assigned Apps </p>}
                        />
                        <Grid className={classes.row} container justify='space-between'>
                          <FormControl fullWidth>
                            <Controller
                              name='reSyncProvider'
                              control={control}
                              rules={{
                                required: appStatusChecked && selectedOptions.length === 0,
                              }}
                              render={({ field }) => (
                                <>
                                  <Autocomplete
                                    multiple
                                    value={selectedOptions}
                                    disabled={type === 'view' || !appStatusChecked}
                                    renderOption={(props, option) => (
                                      <li {...props} style={{ display: 'flex', alignItems: 'center' }}>
                                        <Checkbox
                                          checked={selectedOptions.includes(option)}
                                          onChange={(event) => handleCheckboxChange(event, option)}
                                          style={{ marginRight: 8 }}
                                        />
                                        <ListItemText primary={option} />
                                      </li>
                                    )}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        variant='outlined'
                                        error={!!errors.reSyncProvider && appStatusChecked}
                                        helperText={
                                          errors.reSyncProvider && appStatusChecked
                                            ? 'Please select at least one option'
                                            : ''
                                        }
                                        disabled={type === 'view'}
                                      />
                                    )}
                                    options={options}
                                  />
                                </>
                              )}
                            />
                          </FormControl>
                        </Grid>
                      </div>
                  </>
                )}
              </>
            </Container>
          </Paper>
        </Grid>
        <Grid container justify='space-between'>
          <Paper className={classes.paper}>
            <Container className={classes.tableBox}>
              <p className={classes.boxTitle}>Department</p>
              <>
                {!getDepartmentsReq.isFetching && (
                  <>
                    <Grid className={classes.row} container justify='space-between'>
                      {departmentsView.length === 0 ? (
                        <div>
                          <span>No Departments Found.</span>
                          <Button onClick={() => history.push(handleCompanyUrl('/department/add'))}>
                            Add Department
                          </Button>
                        </div>
                      ) : (
                        <Controller
                          name='base'
                          key={'base'}
                          control={control}
                          defaultValue={currentUser ? currentUser?.ou : ''}
                          render={({ field }) => (
                            <Autocomplete
                              {...field}
                              className={classes.inputTwo}
                              options={departmentsView}
                              disablePortal
                              disabled={type === 'view'}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  variant='outlined'
                                  className={classes.inputTwo}
                                  disabled={type === 'view'}
                                />
                              )}
                              getOptionLabel={(option) => option.ou || ''}
                              onChange={(e, value) => {
                                const selectedValue = value ? `${value.base}` || '' : '';
                                field.onChange(selectedValue);
                              }}
                              value={departmentsView.find((option) => `${option.base}` === field.value) || null}
                            />
                          )}
                        />
                      )}
                    </Grid>
                  </>
                )}
                {getDepartmentsReq.isFetching && <div>Loading...</div>}
              </>
            </Container>
          </Paper>
          <Paper className={classes.paper}>
            <p className={classes.boxTitle}>Groups</p>
            <Container className={classes.tableBox}>
              <>
                {!getGroupsReq.isFetching && (
                  <>
                    <Grid className={classes.row} container justify='space-between'>
                      {allGroupsView.length === 0 ? (
                        <div>
                          <span>No Group Found.</span>
                          <Button onClick={() => history.push(handleCompanyUrl('/groups/add'))}>Add Group</Button>
                        </div>
                      ) : (
                        <>
                          <>
                            <FormControl fullWidth>
                              <Autocomplete
                                multiple
                                options={allGroupsView.map((group) => ({
                                  dn: group.dn,
                                  label: group.cn,
                                  email: group.email,
                                }))}
                                value={selectedGroups}
                                disablePortal
                                getOptionLabel={(option) => option.label}
                                onChange={handleGroupChange}
                                disabled={type === 'view'}
                                renderOption={(props, option) => (
                                  <li {...props}>
                                    <Checkbox checked={selectedGroups.some((group) => group.dn === option.dn)} />
                                    <ListItemText primary={option.label} />
                                  </li>
                                )}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    variant='outlined'
                                    className={classes.inputTwo}
                                    disabled={type === 'view'}
                                  />
                                )}
                              />
                            </FormControl>
                          </>
                          <Controller
                            name='oldgroup'
                            control={control}
                            render={({ field }) => (
                              <Select
                                {...field}
                                multiple
                                value={currentUserAllGroup}
                                onChange={(e) => field.onChange(e.target.value)}
                                className={classes.inputTwo}
                                style={{ display: 'none' }}
                                disabled={type === 'view'}
                                renderValue={(selected: any) => (
                                  <div>
                                    {getCNFromDN(selected as string[], allGroupsView).map((value: any) => (
                                      <span key={value}>{value} </span>
                                    ))}
                                  </div>
                                )}
                              >
                                {allGroupsView.map((group) => (
                                  <MenuItem key={group.dn} value={group.dn}>
                                    <Checkbox checked={field.value?.includes(group.dn)} />
                                    {group.cn}
                                  </MenuItem>
                                ))}
                              </Select>
                            )}
                          />
                        </>
                      )}
                    </Grid>
                  </>
                )}
                {getGroupsReq.isFetching && <div>Loading...</div>}
              </>
            </Container>
          </Paper>
        </Grid>
        {type === 'view' ? (
          ''
        ) : (
          <FormControlLabel
            className={classes.notify}
            control={
              <Controller
                name='notify'
                defaultValue={currentUser?.notify}
                key={'notify'}
                control={control}
                render={({ field, fieldState: { invalid, error } }) => (
                  <Checkbox
                    disabled={type === 'view'}
                    {...field}
                    defaultChecked={currentUser?.notify}
                    onChange={field.onChange}
                    name='notify'
                  />
                )}
              />
            }
            label='Notify User via Email'
          />
        )}
        {type === 'view' ? (
          ''
        ) : (
          <div className={classes.btnBox}>
            {!selfRegister ? (
              <Button
                type='button'
                variant='contained'
                color='primary'
                className={classes.btnWideLeft}
                onClick={() => goBack()}
              >
                Cancel
              </Button>
            ) : null}
            <Button
              type='submit'
              variant='contained'
              color='secondary'
              className={classes.btnWide}
              disabled={!emailValid || !passwordValid || !validation.givenname || !validation.sn}
            >
              {(!!currentUser as boolean) ? 'Save Changes' : 'Create'}
            </Button>
            {selfRegister ? (
              <Link className={classes.link} to='/'>
                Back 2
              </Link>
            ) : null}
          </div>
        )}
      </form>
    </>
  );
});
